
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Taxiserviceinbeed() {



const cardData = {
  keyword: 'Taxi Service in Beed MIDC Maharashtra',
  heading: 'eTravo: Taxi Service in Beed MIDC Maharashtra',
  headingDescription: `eTravo proudly delivers reliable and efficient taxi services in Beed MIDC, Maharashtra, catering to the unique transportation demands of local industries, employees, and business visitors. Whether it’s daily staff commuting, executive travel, or on-demand client transfers, our services are designed to ensure punctuality, comfort, and professionalism at every step. Our modern fleet features GPS-enabled, air-conditioned taxis driven by trained professionals who understand the nuances of industrial and corporate travel. With flexible booking options, competitive pricing, and 24/7 support, eTravo simplifies transportation for companies operating in and around Beed MIDC. Partner with eTravo for seamless, safe, and business-class taxi services that power productivity and peace of mind.`,

  top: 'Top Places to visit in Beed with eTravo',
   "topPlaces": [
    {
      "title": "Beed MIDC Industrial Area",
      "description": "A significant industrial zone in Beed, hosting a variety of industries including agro-processing, textiles, and manufacturing units. eTravo ensures timely and efficient employee transportation to support shift operations and industrial productivity."
    },
    {
      "title": "Beed City Center",
      "description": "The commercial and administrative core of Beed, featuring government offices, banks, and corporate establishments. Our executive cab services facilitate seamless travel for business meetings and official engagements."
    },
    {
      "title": "Beed Railway Station",
      "description": "A crucial railway hub connecting Beed with major cities across India. eTravo offers convenient pickup and drop services, bridging the gap between rail travel and workplace commutes for employees and business travelers."
    },
    {
      "title": "Beed Logistics Hub",
      "description": "An emerging logistics center enhancing the region's warehousing and transportation capabilities. eTravo supports logistics personnel with scheduled and on-demand cab services, ensuring smooth operations."
    },
    {
      "title": "Nearby Business Parks and Tech Zones",
      "description": "Extending our services to adjacent business parks and tech zones, eTravo provides corporate shuttle and cab hire solutions, facilitating inter-zone travel and team commutes."
    },
    {
      "title": "Beed Industrial Warehouses",
      "description": "Supporting large warehouses with scheduled and on-demand cab services for warehouse staff and logistics personnel, ensuring operational continuity."
    },
    {
      "title": "Beed Educational Institutions",
      "description": "Providing transportation solutions for students and faculty members of various educational institutions in Beed, ensuring safe and timely commutes."
    },
    {
      "title": "Beed Healthcare Facilities",
      "description": "Offering reliable cab services for healthcare professionals and patients, ensuring timely arrivals and departures from hospitals and clinics."
    },
    {
      "title": "Beed Retail and Shopping Centers",
      "description": "Facilitating transportation for employees and customers to and from major retail outlets and shopping centers in Beed."
    },
    {
      "title": "Beed Hospitality Sector",
      "description": "Providing transportation solutions for hotel staff and guests, ensuring seamless travel experiences within the hospitality industry."
    }
  ],

 services: [
  {
    name: 'Beed MIDC Taxi Rentals',
    description: `Custom taxi rental plans tailored for businesses operating in Beed MIDC, offering both long-term and short-term options. We provide a fleet maintained to professional standards and flexible booking arrangements to support seamless corporate transportation.`
  },
  {
    name: 'Employee Taxi Service Beed MIDC',
    description: `Reliable daily employee taxi services matched to your shift timings, ensuring punctual and safe travel. All vehicles are GPS-enabled and monitored by our support team for on-time performance and smooth coordination.`
  },
  {
    name: 'Corporate Taxi Services Beed MIDC',
    description: `Corporate-focused taxi services designed for meetings, site visits, and client engagements in Beed MIDC. Our professional drivers and well-maintained cars provide a dependable and comfortable travel experience.`
  },
  {
    name: 'Staff Taxi Hire Beed MIDC',
    description: `Group transport for corporate staff with planned routes and cabs, promoting cost efficiency and team coordination. Vehicles are equipped with GPS and driven by trained drivers to ensure safety and timeliness.`
  },
  {
    name: 'Reliable Corporate Taxi Beed MIDC',
    description: `Our commitment to reliable service includes clean, modern vehicles and professional drivers. We prioritize punctuality, courteous communication, and consistent service for corporate clients.`
  },
  {
    name: 'AC Corporate Taxi Beed MIDC',
    description: `Comfort-first air-conditioned taxi service suitable for Beed’s varying climate. Ideal for executives and daily staff alike, our AC taxis ensure a pleasant ride no matter the weather.`
  },
  {
    name: 'Business Taxi Rentals Beed MIDC',
    description: `Taxi rental services for all business needs, whether it's urgent travel, regular commuting, or event logistics. Our services adapt to your business’s scale and timing requirements.`
  },
  {
    name: 'Affordable Staff Taxi Service Beed MIDC',
    description: `Cost-effective taxi services for staff commuting, perfect for SMEs and larger companies managing transport budgets. Flexible vehicle allocation and transparent pricing help optimize your transport expenses.`
  },
  {
    name: 'Executive Taxi Service Beed MIDC',
    description: `Premium executive travel in luxury taxis with professional chauffeurs. Ideal for VIP transfers, airport pickups, and corporate hospitality to ensure a top-tier experience.`
  },
  {
    name: 'Monthly Corporate Taxi Rentals Beed MIDC',
    description: `Simplify transportation management with monthly fixed-route taxi plans for staff. These plans streamline billing, reduce admin workload, and ensure consistent service quality.`
  },
  {
    name: 'Industrial Area Taxi Transport Beed MIDC',
    description: `Efficient taxi transport for factory staff and workers commuting between Beed industrial zones and residential areas. Routes are optimized for safety, compliance, and minimal delays.`
  },
  {
    name: 'Corporate Client Taxi Beed MIDC',
    description: `Impress clients with polished taxi service tailored to business visitors. From timely airport transfers to guided site visits, we ensure a professional experience throughout.`
  },
  {
    name: 'Business Meeting Taxi Beed MIDC',
    description: `On-demand taxis for executives heading to urgent meetings or business appointments within Beed and neighboring areas. Our prompt dispatch service ensures you're always on time.`
  },
  {
    name: 'Beed Industrial Area Taxi Hire',
    description: `Flexible and fast taxi hire for business use across Beed’s industrial regions. Perfect for logistics, inspections, or admin-related travel, with drivers familiar with local layouts.`
  },
  {
    name: 'Corporate Shuttle Taxi Beed MIDC',
    description: `Shuttle services using vans and minibuses for efficient bulk employee movement during shift hours or company events. Save on costs and reduce carbon footprint with rides.`
  }
],

tableData: [
  ['Beed MIDC Taxi Rentals', 'Employee Taxi Service Beed MIDC'],
  ['Corporate Taxi Services Beed MIDC', 'Staff Taxi Hire Beed MIDC'],
  ['Reliable Corporate Taxi Beed MIDC', 'AC Corporate Taxi Beed MIDC'],
  ['Business Taxi Rentals Beed MIDC', 'Affordable Staff Taxi Service Beed MIDC'],
  ['Executive Taxi Service Beed MIDC', 'Monthly Corporate Taxi Rentals Beed MIDC'],
  ['Industrial Area Taxi Transport Beed MIDC', 'Corporate Client Taxi Beed MIDC'],
  ['Business Meeting Taxi Beed MIDC', 'Beed Industrial Area Taxi Hire'],
  ['Corporate Shuttle Taxi Beed MIDC', '']
],


"whychoose": [
  {
    "WhyChooseheading": "Tailored Taxi Services for Beed MIDC",
    "WhyChoosedescription": "eTravo provides customized taxi solutions specifically designed for businesses and industries located in Beed MIDC, a steadily developing industrial region in Maharashtra. Our services ensure timely and safe transportation for employees, contributing to increased operational efficiency and workforce satisfaction."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Suit Corporate Needs",
    "WhyChoosedescription": "Our fleet includes a variety of well-maintained sedans, SUVs, and multi-utility vehicles. Whether you need transport for daily staff commutes, executive travel, or client visits, we have the right vehicle for every requirement, ensuring safety and comfort at all times."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Local Knowledge",
    "WhyChoosedescription": "Our drivers are highly experienced and possess in-depth knowledge of the Beed MIDC area. Their familiarity with local routes ensures timely pickups, efficient travel, and professional service that aligns with corporate standards."
  },
  {
    "WhyChooseheading": "Flexible Booking Options to Match Shift Patterns",
    "WhyChoosedescription": "Understanding the unique demands of industrial work schedules, we offer highly flexible booking solutions. Choose from scheduled rides, on-demand taxis, or long-term arrangements to match your operational shifts perfectly."
  },
  {
    "WhyChooseheading": "Real-Time GPS Tracking for Safety and Transparency",
    "WhyChoosedescription": "All taxis are equipped with GPS tracking systems to enable real-time monitoring. This enhances safety for passengers, ensures driver accountability, and provides employers with peace of mind regarding employee travel."
  },
  {
    "WhyChooseheading": "Transparent Billing with Detailed Invoices",
    "WhyChoosedescription": "We offer detailed, transparent billing for every trip. Our invoices clearly outline trip details and fare components, making financial tracking and corporate reimbursements smooth and hassle-free."
  },
  {
    "WhyChooseheading": "Strict Safety and Hygiene Standards",
    "WhyChoosedescription": "eTravo maintains the highest standards of safety and hygiene. Our vehicles are regularly sanitized, and our drivers follow all safety protocols to ensure a secure and clean travel environment for every passenger."
  },
  {
    "WhyChooseheading": "Dedicated Account Management Support",
    "WhyChoosedescription": "Each corporate client is assigned a dedicated account manager to oversee bookings, provide support, and resolve issues promptly. We ensure a seamless taxi service experience tailored to your business needs in Beed MIDC."
  }
]


}

const faqData = [
  [
    {
      question: "Which areas do your Beed MIDC taxi services cover?",
      answer: "Our taxi services cover the entire Beed MIDC region and adjacent industrial areas, providing reliable transport for employees and executives."
    },
    {
      question: "Can we arrange shift-wise transportation for factory workers?",
      answer: "Yes, we support flexible scheduling for shift-wise transportation to accommodate day, night, and rotating shifts."
    },
    {
      question: "Do you provide GST-compliant monthly invoices for businesses?",
      answer: "Absolutely. We offer clear, GST-compliant monthly billing with detailed trip breakdowns for corporate clients."
    },
    {
      question: "Are your drivers trained to handle industrial area routes?",
      answer: "Yes, our drivers are well-versed with Beed MIDC routes and trained in safety, punctuality, and professional conduct."
    },
    {
      question: "What safety measures do you follow for passenger transport?",
      answer: "We implement GPS tracking, daily vehicle sanitization, driver verification, and emergency support to ensure safety."
    },
    {
      question: "Is there any corporate liaison or account management support?",
      answer: "Yes, we assign dedicated account managers and provide priority customer support for our business clients."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Suresh Shinde",
    designation: "Logistics Head, Beed Steel Works",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s punctual service and professional drivers have made employee transport more efficient and worry-free.”"
  },
  {
    name: "Ms. Kavita More",
    designation: "Admin Officer, Beed Textiles Ltd.",
    rating: [1, 1, 1, 1, 1],
    text: "“The team at eTravo understands our transportation needs well and delivers consistent service. Highly recommended for industrial clients.”"
  }
];


































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Taxi Service in Beed MIDC Maharashtra",
  "image": "https://www.etravo.in/images/keyword/taxi-service-beed-midc.jpg",
  "description": "Reliable corporate taxi service in Beed MIDC Maharashtra offering employee transport, business travel, industrial area taxi rentals, and affordable AC corporate taxis with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1699",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/taxi-service-beed-midc"
  }
};






    return (
        <div>
<Helmet>
  <title>Taxi Service in Beed MIDC Maharashtra | Corporate & Industrial Taxis | eTravo</title>
  <meta 
    name="description" 
    content="Book reliable corporate taxi service in Beed MIDC Maharashtra for staff commute, business meetings, and industrial transport. Affordable AC corporate taxis available at eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/82.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Taxiserviceinbeed;